// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ONTTr","inner":"Footer_inner__3egSO","nextIcon":"Footer_nextIcon__64Y05","innerLeft":"Footer_innerLeft__3uKcY"};